export default __webpack_public_path__ + "img/55.50bc60d.svg";